import { render, staticRenderFns } from "./fm-code.vue?vue&type=template&id=1f72c523&"
import script from "./fm-code.vue?vue&type=script&lang=js&"
export * from "./fm-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports